import { adminHttpClient } from '../commons/adminHttpClient'

export const canCurrentUserSubmitExpenses = (planPeriodId?: string): Promise<boolean> => {
  return adminHttpClient.get(`Companies/CanCurrentUserSubmitExpensesForPlanPeriod/${planPeriodId}`)
}
